<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:10px;">Dedication</h1>
<p style="text-indent:0em;">For my wonderful daughter E, who gave me reason and inspiration to write this book. I love you very much and am proud to be your father.</p><br/>
<p style="text-indent:0em;">A huge thank you to my mother Sue, who has kept me focussed throughout my life and while I was writing this book. Love you lots Mum.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7c3ed106